module.exports = __webpack_public_path__ + "img/partner04.28b0b982.png";